module.exports = __webpack_public_path__ + "assets/img/SRG-Finance-Pillar-Page-Resource.b73f3019.jpg";